import * as React from 'react';
import { IconProps, SIZE_MAP } from '../types';
import { cn } from '../../../utils/cn';

const XIcon = ({ size = 'lg', className, ...props }: IconProps) => {
  const px = SIZE_MAP[size];

  return (
    <svg
      width={px}
      height={px}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-primary', className)}
      {...props}
    >
      <path
        d="M17.4697 5.46967C17.7626 5.17678 18.2373 5.17678 18.5302 5.46967C18.8231 5.76256 18.8231 6.23732 18.5302 6.53022L13.0605 11.9999L18.5302 17.4697L18.582 17.5263C18.8223 17.8209 18.8048 18.2556 18.5302 18.5302C18.2556 18.8048 17.8209 18.8223 17.5263 18.582L17.4697 18.5302L11.9999 13.0605L6.53022 18.5302C6.23732 18.8231 5.76256 18.8231 5.46967 18.5302C5.17678 18.2373 5.17678 17.7626 5.46967 17.4697L10.9394 11.9999L5.46967 6.53022C5.17678 6.23732 5.17678 5.76256 5.46967 5.46967C5.76256 5.17678 6.23732 5.17678 6.53022 5.46967L11.9999 10.9394L17.4697 5.46967Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default XIcon;
